import { GetCookie } from '@reynolds/cookiemanager';
import { WS_TOKEN } from './collections/constants';
import { createIdleListener, idleMiddleware } from './middleware/IdleMonitor';
import { Middleware } from 'redux';
import { configureStore as configureStore_, getDefaultMiddleware } from '@reduxjs/toolkit';
import { observe } from 'redux-observers';
import { persistStore, FLUSH, REGISTER, REHYDRATE, PAUSE, PERSIST, PURGE } from 'redux-persist';
// import persistSessionStorage from 'redux-persist/es/storage/session';
import * as StoreModule from './store';
import { createSentryEnhancer } from './createSentryEnhancer';
import * as Sentry from '@sentry/browser';

const { reducers, observers } = StoreModule;
const isCookiesEnabled = navigator.cookieEnabled;

export const configureStore = (initialState?: StoreModule.IStoreState) => {
    const enableDebug = process.env.NODE_ENV === 'development';
    const token = GetCookie(WS_TOKEN);
    const optionalMiddlewares: Middleware[] = [];
    if (enableDebug) {
        const { logger } = require('redux-logger');
        optionalMiddlewares.push(logger);
    }

    const store = configureStore_({
        preloadedState: initialState ? { ...initialState } : undefined,
        reducer: reducers,
        middleware: [...getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            }}), idleMiddleware, ...optionalMiddlewares],
        devTools: process.env.NODE_ENV === 'development',
        enhancers: [createSentryEnhancer()],
    });
    Sentry.init({
        ignoreErrors: ['Non-Error promise rejection captured'],
        sampleRate: 0.5,
    });
    // Instantiate observers to watch the data and dispatch actions on changes
    // to the store.  Not UI dependant.
    observe(store, observers);

    // Link the store to the persistor to allow us to share the store
    // across sessions.
    const persistor = persistStore(store);

    const holdtokenKey = 'HoldToken';
    if (isCookiesEnabled) {
        try {
            if (sessionStorage.getItem(holdtokenKey) !== token) {
                sessionStorage.setItem(holdtokenKey, token ?? '');
                persistor.purge();
            }
        } catch (error) {
            // console.log(error);
        }
    }

    // Create middle ware for idle listener
    createIdleListener(store);

    return { persistor, store };
};

